import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import StrategicServicesModules from "./sections/StrategicServicesModules";
import WhyChooseUs from "./sections/WhyChooseUs";
import AuditProcess from "./sections/AuditProcess";
import ScheduleAMeeting from "./sections/ScheduleAMeeting";
import Contact from "./sections/Contact";
import FooterInformation from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <StrategicServicesModules />
      <WhyChooseUs />
      <AuditProcess />
      <ScheduleAMeeting />
      <Contact />
      <FooterInformation />
    </div>;
}